import { NavLink, Outlet } from 'react-router-dom'
import { ThemeToggle } from '@diwata/ironvale'
import { CaptureButton } from './CaptureButton'
import './layout.css'

function navClass({ isActive }: { isActive: boolean }) {
  return isActive ? 'iv-nav-item iv-nav-item--active' : 'iv-nav-item'
}

export function Layout() {
  return (
    <div className="cp-shell">
      <nav className="cp-nav">
        <div className="cp-nav-brand">Conclave</div>
        <div className="cp-nav-links">
          <NavLink to="/" end className={navClass}>Familiars</NavLink>
          <NavLink to="/circles" className={navClass}>Circles</NavLink>
        </div>
        <CaptureButton />
        <div className="cp-nav-footer">
          <NavLink to="/settings" className="cp-nav-settings">Settings</NavLink>
          <ThemeToggle className="cp-nav-mode" />
        </div>
      </nav>
      <main className="cp-main">
        <Outlet />
      </main>
    </div>
  )
}
